import { makeStyles } from "@material-ui/core/styles";
import React, { useState } from "react";
import { CircularProgress, Tooltip } from "@material-ui/core";
import { Link, useNavigate } from "react-router-dom";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import PracticumScoreChart from "./PracticumScoreChart";
import { API_URL } from "../../../config";
import PlotpracticumScoreChart from "./PlotlyGraph";

const useStyles = makeStyles(() => ({
  customTooltip: {
    backgroundColor: "#800080",
    fontSize: "13px",
  },
  dropdown: {
    position: "absolute",
    right: "90px",
    backgroundColor: "white",
    border: "1px solid #ddd",
    padding: "10px",
    borderRadius: "4px",
    marginTop: "25px",
    boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
    zIndex: 1,
    width: "fit-content",
    height: "220px",
    overflowY: "auto",

    scrollbarWidth: "thin", // Firefox
    "&::-webkit-scrollbar": {
      width: "8px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "rgba(0,0,0,0.2)",
      borderRadius: "4px",
    },
    "&::-webkit-scrollbar-button": {
      display: "none", // 🚫 Hides the up/down arrows
      height: 0,
    },
  },
  hoverp: {
    backgroundColor: "#f1f1f1",
    color: "#000",
    "&:hover": {
      backgroundColor: "#800080",
      padding: "14px",
      color: "white",
    },
  },
}));

function RowComponent({
  item,
  filteredSessions,
  index,
  createMultiSessions,
  loader,
}) {
  const classes = useStyles();
  const [showDropdown, setShowDropdown] = useState(false);
  const accessToken = localStorage.getItem("accessToken");
  const navigate = useNavigate();

  const [graphData, setGraphData] = useState([]);

  const toggleDropdown = (e) => {
    e.preventDefault();
    setShowDropdown((prev) => !prev);
  };
  const logout = () => {
    localStorage.clear();
    window.location.reload();
  };
  const percentage = React.useMemo(() => {
    const totalScore = item?.practicum?.reduce(
      (acc, item) => acc + item.score,
      0
    );
    const totalMaxScore = item?.practicum?.reduce(
      (acc, item) => acc + item.max_score,
      0
    );

    const final = (totalScore / totalMaxScore) * 100;

    return final.toFixed(1);
  }, [item]);

  return (
    <>
      <tr key={item.id}>
        <td className="column-practicum-tr">
          <div className="practicum-number">{index}</div>
        </td>
        <td className="column-objective">{item.objective}</td>
        <td
          className="column-score-value"
          style={{
            backgroundColor: "#f1f1f1",
            color: "#000",
            width: 260,
            padding: 0,
            overflow: "hidden",
            position: "relative",
            height: 20,
          }}
        >
          <div style={{ position: "relative", width: "100%", height: "100%" }}>
            {/* Background bar (gray) */}
            <div
              style={{
                position: "absolute",
                left: 0,
                top: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "#f1f1f1",
              }}
            />

            {/* Progress bar (purple) */}
            <div
              style={{
                position: "absolute",
                left: 0,
                top: 0,
                width: `${percentage}%`,
                height: "100%",
                backgroundColor: "#800080",
                borderRadius: "5px 0 0 5px",
                transition: "width 0.3s ease-in-out",
              }}
            />

            {/* Percentage text */}
            <div
              style={{
                position: "absolute",
                left: 50,
                top: 0,
                height: "100%",
                display: "flex",
                alignItems: "center",
                color: "#fff",
                fontWeight: "bold",
                zIndex: 2,
                textAlign: "center",
              }}
            >
              {percentage}%
            </div>
          </div>
        </td>

        <td className="column-icons">
          <div className="icons-container">
            <Tooltip
              classes={{
                tooltip: classes.customTooltip,
              }}
              title={"Choose session to view."}
              placement="top"
            >
              <a
                href="javascript:void"
                onClick={toggleDropdown}
                data-tip="Choose session to view"
                className="downloadimg tooltip2"
              >
                <img
                  src="/icons/graph-icon.png"
                  alt="Graph Icon"
                  style={{
                    width: "24px",
                    height: "24px",
                    cursor: "pointer",
                    objectFit: "contain",
                  }}
                />
              </a>
            </Tooltip>
            {showDropdown && (
              <div className={classes.dropdown}>
                <span
                  style={{
                    fontSize: "14px",
                    fontWeight: "bold",
                    marginBottom: "10px",
                    display: "block",
                  }}
                >
                  Select a Session
                </span>
                {filteredSessions?.length > 0 ? (
                  filteredSessions?.map((session, index) => (
                    <div
                      // to={`/create/report/0/12/${session.id}/all/12?practicum=1`}
                      // target="_blank"
                      key={session.id}
                      onClick={() => {
                        localStorage.setItem("selectedSession", session.id);
                        navigate(
                          `/create/report/0/12/${session.id}/all/12?practicum=1`
                        );
                      }}
                    >
                      <p
                        style={{
                          fontSize: "14px",
                          cursor: "pointer",
                          marginBottom:
                            filteredSessions?.length - 1 === index
                              ? "0"
                              : "10px",

                          padding: "10px",
                        }}
                        className={classes.hoverp}
                      >
                        {session.name} - {session.practicumId}
                      </p>
                    </div>
                  ))
                ) : (
                  <p>No sessions available</p>
                )}
              </div>
            )}
            <Tooltip
              classes={{
                tooltip: classes.customTooltip,
              }}
              title={"Data History."}
              placement="top"
            >
              <a
                href="javascript:void"
                onClick={() => {
                  if (loader) {
                    return;
                  }

                  createMultiSessions(
                    filteredSessions.map((session) => session.id),
                    item.id
                  );
                }}
                data-tip="Data History."
                className="downloadimg tooltip2"
              >
                {loader == item.id ? (
                  <CircularProgress
                    size={17}
                    style={{
                      color: "#800080",
                      marginTop: "3px",
                    }}
                  />
                ) : (
                  <img
                    src="/icons/pie-icon.png"
                    alt="Graph Icon"
                    style={{
                      width: "24px",
                      height: "24px",
                      cursor: "pointer",
                      objectFit: "contain",
                    }}
                  />
                )}
              </a>
            </Tooltip>
            <Tooltip
              classes={{
                tooltip: classes.customTooltip,
              }}
              title={"Interview History."}
              placement="top"
            >
              <a
                href="javascript:void"
                style={{
                  background: "transparent",
                  border: "none",
                  cursor: "pointer",
                  padding: 0,
                  margin: 0,
                  outline: "none",
                }}
                data-tip="Interview History."
                onClick={() => setGraphData(item.practicum)}
              >
                <img
                  src="/icons/bar-icon.png"
                  alt="Graph Icon"
                  style={{
                    width: "24px",
                    height: "24px",
                    cursor: "pointer",
                    objectFit: "contain",
                  }}
                />
              </a>
            </Tooltip>
          </div>
        </td>
      </tr>

      <Modal
        isOpen={graphData.length > 0}
        toggle={() => {
          setGraphData([]);
        }}
        className="connect-box"
        centered={true}
        style={{
          maxWidth: "900px",
        }}
      >
        <ModalHeader
          toggle={() => {
            setGraphData([]);
          }}
        >
          <span className="ml-1 roititle font-weight-bold">
            Practicum Score History - Practicum {index}
          </span>
        </ModalHeader>
        <ModalBody>
          {/* <PracticumScoreChart
            id={index}
            data={graphData}
            setGraphData={setGraphData}
          /> */}
          <PlotpracticumScoreChart
            id={index}
            data={graphData}
            setGraphData={setGraphData}
          />
        </ModalBody>
      </Modal>
    </>
  );
}

export default RowComponent;
